import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAppStore } from "../stores/appStore";
import { Controller, useForm, useWatch } from "react-hook-form";
import { generateColor } from "../utils/generateRandomColor";
import constants from "../utils/constants";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const DeleteTags = () => {
  const updatePageOpen = useAppStore((state) => state.updatePageOpen);
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
    reset,
    resetField,
    setValue,
    getValues,
  } = useForm({
    reValidateMode: "onChange",
    defaultValues: {
      tags: [],
    },
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [tags, setTags] = useState([]);
  const [tagsLoading, setTagsLoading] = useState(true);
  const [tagsError, setTagsError] = useState(null);

  const fetchTags = async () => {
    try {
      setTagsLoading(true);
      const url = `${constants.backend_url}/tags/`;
      const res = await axios.get(url);
      setTags(res.data);
      setTagsLoading(false);
    } catch (error) {
      setTagsLoading(false);
      setTagsError(error);
      console.log(error.response);
    }
  };

  useEffect(() => {
    updatePageOpen("settings");
    fetchTags();
  }, []);

  const handleTagsDelete = async (event) => {
    let deleteTagReq = [];
    deleteTagReq = event.tags.map((tag) => tag._id);

    try {
      setLoading(true);
      let url = `${constants.backend_url}/tags/delete`;
      await axios.patch(url, deleteTagReq, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (window.confirm("Tags deleted sucessfully")) {
        window.location = "/settings";
      }
    } catch (error) {
      console.log(error.response.data);
    } finally {
      await fetchTags();
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{ display: "flex", gap: 2, width: "100%", alignItems: "center" }}
      component="form"
      onSubmit={handleSubmit(handleTagsDelete)}
    >
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ fontFamily: "glancyrregular" }}
      >
        Delete Tags
      </Typography>

      <Controller
        control={control}
        name="tags"
        defaultValue={[]}
        rules={{ required: true }}
        render={({ field: { ref, onChange, ...field } }) => (
          <Autocomplete
            multiple
            options={tags}
            loading={tagsLoading}
            sx={{ flex: 1 }}
            defaultValue={[]}
            getOptionLabel={(option) => option.name}
            onChange={(_, data) => onChange(data)}
            size="small"
            renderInput={(params) => (
              <TextField
                {...field}
                {...params}
                size="small"
                placeholder="Select tags and click delete"
                inputRef={ref}
                variant="outlined"
                sx={{ backgroundColor: "white" }}
                error={errors.tags !== undefined || tagsError !== null}
              />
            )}
            renderTags={(value, getTagProps) => {
              return value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={
                    <Typography variant="p" fontWeight="bold">
                      {option.name}
                    </Typography>
                  }
                  size="small"
                  sx={{
                    backgroundColor: generateColor(option.name),
                    color: "white",
                  }}
                  {...getTagProps({ index })}
                />
              ));
            }}
          />
        )}
      />
      <Button
        variant="contained"
        color="error"
        type="submit"
        startIcon={loading ? <CircularProgress size="1rem" /> : <DeleteIcon />}
      >
        Delete
      </Button>
    </Box>
  );
};

export default DeleteTags;
